// Вкладка «Лента событий»: что вокруг карточки происходило.
//
// ЧЕМ ЛЕНТА ОТЛИЧАЕТСЯ ОТ ЖУРНАЛА. Журнал отвечает «что изменилось в записи», лента —
// «что происходило с делом»: письмо клиенту, звонок, комментарий координатора, переход
// стадии. Смешивать их нельзя: в журнале ищут виноватого в цифре, в ленте — контекст
// разговора. Слитые вместе, они не годятся ни для того, ни для другого.
//
// ПОЧЕМУ СПИСОК, А НЕ ТАБЛИЦА. У события нет колонок: у него есть время, автор и текст
// произвольной длины. В таблице такой текст либо режется, либо ломает строку.

import { fmtDate } from '../lib/format'

import type { Событие } from './types'
import type { Ответ } from './useSourceData'

const ПОДПИСЬ_ВИДА: Record<Событие['вид'], string> = {
  комментарий: 'Комментарий',
  письмо: 'Письмо',
  звонок: 'Звонок',
  стадия: 'Смена стадии',
  задача: 'Задача',
}

/** Данные приходят пропом: их же считает счётчик на полосе вкладок. */
export function FeedTab({ ответ }: { ответ: Ответ<Событие[]> }) {
  const { данные, отказ, ждём } = ответ

  return (
    <div className="card">
      <h2>События по карточке</h2>
      {отказ && (
        <div className="notice err">
          Лента не пришла: {отказ}. Пустой список здесь означал бы «ничего не происходило»,
          поэтому мы его не показываем.
        </div>
      )}
      {!отказ && ждём && <div className="skeleton" />}
      {!отказ && !ждём && данные && данные.length === 0 && (
        <div className="empty">
          <div className="empty-title">Событий нет</div>
          <div className="empty-hint">
            По карточке не записано ни писем, ни звонков, ни комментариев.
          </div>
        </div>
      )}
      {!отказ && !ждём && данные && данные.length > 0 && (
        <ul className="plain-list">
          {данные.map((с) => (
            <li key={с.id}>
              <div>
                <span className="badge work">{ПОДПИСЬ_ВИДА[с.вид] ?? с.вид}</span>{' '}
                <b>{с.кто}</b> <span className="muted">{fmtDate(с.когда, true)}</span>
              </div>
              <div>{с.текст}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
